
import React , {Component} from 'react';

import './index.css';

class CommentList extends Component {

  render () {
      const comments = this.props.comments;

      return (
        <div>
          {comments.map((comment,i)=>{
            return(
              <div key={i} className="comment">
                <div>
                  <span>{comment.username}：</span>
                </div>
                <p>
                  {comment.content}
                </p>
              </div>
            )
          })}
        </div>
      )
  }

}


export default CommentList;



// WEBPACK FOOTER //
// ./src/CommentList.js